import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import QuickTip from 'shared/components/QuickTip';
import {t} from 'shared/core';

const TaskCompleted = observer(({uiState}) => {
  const {task} = uiState;
  const quickTipParams = {
    trait: 'success',
    actions: task.hasLink('uncomplete') ?
      [{ caption: t('inbox.Undo'), onClick: () => uiState.uncompleteTask() }] : []
  };

  return (
    <QuickTip {...quickTipParams}>
      <FormattedMessage id='inbox.This task has been completed.'/>
    </QuickTip>
  );
});

export default TaskCompleted;
